import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import Moment from 'moment';
import { Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import DateTime from "_class/DateTime";
import User from "_class/User";
import { getUserAssessmentDates } from "helpers/user";
import { setPageTitle } from "actions/header";
import { getSection } from "actions/sections";
import DatePickers from "./Partials/DatePickers";
import UserAssessments from './Partials/UserAssessments';
import { Spinner } from "UI";
import { Button, translate } from '@haldor/ui';

var SectionProgress = /*#__PURE__*/function (_Component) {
  _inherits(SectionProgress, _Component);

  var _super = _createSuper(SectionProgress);

  function SectionProgress(props) {
    var _this;

    _classCallCheck(this, SectionProgress);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var groupId = null;

      if (_this.props.match != null) {
        if (_this.props.match.params.groupId != null) {
          groupId = _this.props.match.params.groupId;
        }
      }

      if (groupId == null) {
        groupId = _this.props.groupId;
      }

      if (_this.props.activeSection != null) {
        if (_this.props.activeSection.id == groupId) {
          _this.setTitleAndStudent();

          return true;
        }
      }

      _this.props.getSection(groupId).then(function () {
        _this.setTitleAndStudent();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setTitleAndStudent", function () {
      var activeSection = _this.props.activeSection;
      var studentId = null;
      var student = null;

      if (_this.props.match != null) {
        if (_this.props.match.params.userId != null) {
          studentId = _this.props.match.params.userId;
        }
      }

      if (studentId == null) {
        studentId = _this.props.userId;
      }

      var currentUser = new User(_this.props.currentUser);

      if (currentUser.isStudent()) {
        student = _this.props.currentUser;
      } else {
        var foundStudent = activeSection.students.find(function (t) {
          return t.id == studentId;
        });

        if (foundStudent != null) {
          student = foundStudent;

          _this.props.setPageTitle(activeSection.title + ' / ' + foundStudent.firstName + " " + foundStudent.lastName);
        }
      }

      if (student != null) {
        _this.setState({
          loading: false,
          student: student
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "updateDates", function () {
      var _this$state = _this.state,
          start = _this$state.start,
          end = _this$state.end;
      localStorage.setItem("assessment-start-date", new DateTime(start).getDateStamp());
      localStorage.setItem("assessment-end-date", new DateTime(end).getDateStamp());

      _this.setState({
        currentStart: start,
        currentEnd: end
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDateChange", function (_ref) {
      var start = _ref.start,
          end = _ref.end;

      if (start == "Invalid date") {
        start = Moment().subtract(1, "years");
      }

      if (end == "Invalid date") {
        end = Moment().add(1, "years");
      }

      _this.setState({
        start: new DateTime(start).getDateStamp(),
        end: new DateTime(end).getDateStamp()
      });
    });

    _this.state = {
      loading: true,
      student: null,
      end: getUserAssessmentDates().end,
      start: getUserAssessmentDates().start,
      currentEnd: getUserAssessmentDates().end,
      currentStart: getUserAssessmentDates().start
    };
    return _this;
  }

  _createClass(SectionProgress, [{
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          loading = _this$state2.loading,
          student = _this$state2.student;
      var groupId = null;

      if (this.props.match != null) {
        if (this.props.match.params.groupId != null) {
          groupId = this.props.match.params.groupId;
        }
      }

      if (groupId == null) {
        groupId = this.props.groupId;
      }

      if (this.props.activeSection == null && student == null || loading) {
        return /*#__PURE__*/React.createElement("div", {
          className: "progress"
        }, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }

      var user = new User(this.props.currentUser);
      var isStudent = user.isStudent();

      if (isStudent) {
        var _this$props$match, _this$props$match2, _this$props$match2$pa;

        var studentId;

        if (((_this$props$match = this.props.match) === null || _this$props$match === void 0 ? void 0 : _this$props$match.params) != null && ((_this$props$match2 = this.props.match) === null || _this$props$match2 === void 0 ? void 0 : (_this$props$match2$pa = _this$props$match2.params) === null || _this$props$match2$pa === void 0 ? void 0 : _this$props$match2$pa.userId) != null) {
          studentId = this.props.match.params.userId;
        } else {
          studentId = this.props.userId;
        }

        if (studentId == null || studentId != this.props.currentUser.id) {
          return /*#__PURE__*/React.createElement(Redirect, {
            to: "/404"
          });
        }
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "progress single-task"
      }, /*#__PURE__*/React.createElement("div", {
        className: "single-section"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row-half static"
      }, /*#__PURE__*/React.createElement(DatePickers, {
        onChange: this.onDateChange,
        startDate: this.state.start,
        endDate: this.state.end
      })))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: "1em"
        }
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.updateDates
      }, this.props.translate("update")))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }), /*#__PURE__*/React.createElement("div", {
        className: "single-section-divider",
        style: {
          marginBottom: '3rem'
        }
      }), /*#__PURE__*/React.createElement(UserAssessments, {
        studentId: student.id,
        sectionId: groupId,
        start: this.state.currentStart,
        end: this.state.currentEnd
      }));
    }
  }]);

  return SectionProgress;
}(Component);

function mapStateToProps(state) {
  return {
    activeSection: state.sections.activeSection,
    currentUser: state.user.currentUser,
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps, {
  getSection: getSection,
  setPageTitle: setPageTitle
})(SectionProgress);